import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow42_1Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow42_1 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("DISASSEMBLY_DECONSTRUCTION_DEMOLITION") || "Disassembly, deconstruction and demolition"}
        subDescription={t("DISASSEMBLY_DECONSTRUCTION_DEMOLITION_DESC") || "Enter information about the process, energy, fuel and material inputs for the product product at the disassembly/deconstruction & demolition phase (e.g., fuel for lifts or forklifts, electricity for tools). Also state the outputs if additional material or water is used. When electricity or fuel is consumed, the output (emissions) are automatically calculated."}
        isNormal={true}
        number={"42.1"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-42-1-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow42_1Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow42_1;

